import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import moment from 'moment';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import AccessibleDatePicker from '@bibliocommons/base-accessibility-date-picker';
import { PrimaryGhostButton, PrimaryButton, TextButton } from '@bibliocommons/base-buttons';
import { CalendarEmpty } from '@bibliocommons/base-icons';
import { FormattedMessage } from 'react-intl';
import BorrowingBatchActionsOverlay from '../../shared/BorrowingBatchActionsOverlay';
import ShortFormattedDate from '../../../shared/ShortFormattedDate';
import { holdItemShape } from '@bibliocommons/bc-prop-types';

import './EditHoldDatesBatchActions.scss';


const renderSubtitle = () => (
  <div>
    <FormattedMessage tagName="p" id="holds_edit_pause_dates_description" />
    <FormattedMessage tagName="p" id="holds_chosen_dates_subtitle" />
  </div>
);

export default class EditHoldDatesBatchActions extends BcReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      showDatePicker: false,
      date: null
    };
    this.bindAll('handleDate', 'renderUntilDate', 'handleUpdatePauseEndDate');
  }

  handleDate(dateValue) {
    this.setState({
      date: dateValue
    });
  }

  handleUpdatePauseEndDate() {
    const { items, handleUpdateHoldsPauseEndDate } = this.props;
    const holdIds = items
      .map(item => item.get('holdsId'))
      .toSet()
      .toList()
      .toJS();

    handleUpdateHoldsPauseEndDate(holdIds, this.state.date);
    this.props.handleClose();
  }

  renderUntilDate() {
    return (
      <div className="edit-hold-until-date">
        <AccessibleDatePicker
          open={this.state.showDatePicker}
          onDateChange={(dateValue) => this.setState({ date: dateValue })}
          isOutsideRange={(day) => !day.isAfter(moment(), 'day')}
          handleClose={() => this.setState({ showDatePicker: false })}>
          <PrimaryGhostButton
            handleClick={() => this.setState({ showDatePicker: true })}
            className="edit-holds-select-dates-button">
            <CalendarEmpty />
            <span>
              {this.state.date ?
                <ShortFormattedDate value={this.state.date} /> : <FormattedMessage id="select_a_date" />
              }
            </span>
          </PrimaryGhostButton>
        </AccessibleDatePicker>
      </div>
    );
  }

  renderFooter() {
    return (
      <div className="edit-hold-date-submit">
        <PrimaryButton className="pull-left" disabled={!this.state.date} handleClick={() => this.handleUpdatePauseEndDate()}>
          <FormattedMessage id="edit_holds_date_button" />
        </PrimaryButton>
        <TextButton className="btn btn-link pull-left" handleClick={this.props.handleClose}>
          <FormattedMessage id="button_nevermind_close" />
        </TextButton>
      </div>
    );
  }

  render() {
    return (
      <BorrowingBatchActionsOverlay
        open={this.props.open}
        className="cp-edit-hold-date-batch-actions-overlay"
        handleClose={this.props.handleClose}
        header={<FormattedMessage id="edit_holds_date_header" values={{ count: this.props.items.size }} />}
        subtitle={renderSubtitle()}
        footer={this.renderFooter()}>
        <div className="until-date">
          <FormattedMessage tagName="strong" id="pause_holds_until" />
          {this.renderUntilDate()}
        </div>
      </BorrowingBatchActionsOverlay>
    );
  }
}

EditHoldDatesBatchActions.propTypes = {
  handleUpdateHoldsPauseEndDate: PropTypes.func.isRequired,
  items: ImmutablePropTypes.listOf(holdItemShape)
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/EditHoldDatesBatchActions/EditHoldDatesBatchActions.jsx